<template>
  <span :data-check="check ? check : null" :data-icon="icon || null">{{
    text
  }}</span>
</template>

<script lang="ts">
export default {
  name: 'Tag',

  props: {
    text: String,
    icon: {
      type: String,
      default: ''
    },
    check: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

span {
  box-sizing: border-box;
  display: inline-block;
  border: 1px solid var.$color-border-gray;
  border-radius: 3px;
  color: var.$color-gray;
  text-align: center;
  font-size: 1rem;
  font-weight: bold;
  line-height: 22px;
  padding-right: 10px;
  padding-left: 10px;
  letter-spacing: normal;

  &[data-icon]::before {
    margin-right: 3px;
    vertical-align: -1px;
  }

  &[data-icon='heart']::before {
    display: inline-block;
    content: '';
    background: url('~@/assets/images/icon/heart-gray.svg') no-repeat;
    background-size: 100% 100%;
    width: 11px;
    height: 10px;
  }

  &[data-icon='hospital']::before {
    display: inline-block;
    content: '';
    background: url('~@/assets/images/icon/hospital-02-gray.svg') no-repeat;
    background-size: 100% 100%;
    width: 11px;
    height: 10px;
  }

  &[data-icon='document']::before {
    display: inline-block;
    content: '';
    background: url('~@/assets/images/icon/document-gray.svg') no-repeat;
    background-size: 100% 100%;
    width: 8px;
    height: 10px;
  }

  &[data-icon='tag']::before {
    display: inline-block;
    content: '';
    background: url('~@/assets/images/icon/tag.svg') no-repeat;
    background-size: 100% 100%;
    width: 11px;
    height: 10px;
  }

  &[data-check='true'] {
    border-color: var.$color-main;
    color: var.$color-main-text;

    &[data-icon='heart']::before {
      background-image: url('~@/assets/images/icon/heart.svg');
    }

    &[data-icon='hospital']::before {
      background-image: url('~@/assets/images/icon/hospital-02.svg');
    }

    &[data-icon='document']::before {
      background-image: url('~@/assets/images/icon/document.svg');
    }
  }
}
</style>
